import { Fetcher } from '@Types/fetcher'
import useBaseFetcher from '../base'
import { SetupMonitoringStyleDTO } from '@Types/harvesterPreference'

function useSetupMonitoringStyle(): Fetcher {
  const [baseFetcher, meta] = useBaseFetcher(true)

  const setupMonitoringStyle = async (formData: SetupMonitoringStyleDTO) => {
    return await baseFetcher(
      `${import.meta.env.VITE_APP_URL}/onboarding/complete?requester=shopify`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      },
      undefined,
      ['me'],
    )
  }

  return [setupMonitoringStyle, meta]
}

export default useSetupMonitoringStyle
